// A random string and unique enough string
// to identify that a method has been aborted
export const WORKER_ABORTABLE_SERVICE_ABORTED = `ABORTABLE_SERVICE_ABORTED$_0.39574939029022294%`;
export type AbortControllers = Map<string, AbortController>;
